import {ConfigProvider} from "../context/ConfigContext";
import {ModalProvider} from "../context/ModalContext";
import {TextSectionsListProvider} from "../context/TextSectionsListContext";
import {AuthProvider} from "../context/LoginContext";
import {SavedConfigurationsProvider} from "../context/SavedConfigurationsContext";
import {EditTypeProvider} from "../context/EditTypeContext";
import {LoaderProvider} from "../context/LoaderContext";
import {PriceProvider} from "../context/PriceContext";
import {WorkingSizeProvider} from "../context/WorkingSizeContext";
import {LettersProvider} from "../context/LettersContext";

export const Providers = ({children}) => {
    return (
        <ConfigProvider>
            <WorkingSizeProvider>
                <PriceProvider>
                    <TextSectionsListProvider>
                        <LettersProvider>
                            <ModalProvider>
                                <AuthProvider>
                                    <SavedConfigurationsProvider>
                                        <EditTypeProvider>
                                            <LoaderProvider>
                                                {children}
                                            </LoaderProvider>
                                        </EditTypeProvider>
                                    </SavedConfigurationsProvider>
                                </AuthProvider>
                            </ModalProvider>
                        </LettersProvider>
                    </TextSectionsListProvider>
                </PriceProvider>
            </WorkingSizeProvider>
        </ConfigProvider>
    )
}